import { useState, useEffect } from 'react';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

export default function MentorConvites() {
  const { token } = useAuth();
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [turmaId, setTurmaId] = useState('');
  const [turmas, setTurmas] = useState([]);
  const [tipo, setTipo] = useState('aluno'); // 'aluno' ou 'colaborador'
  const [admin, setAdmin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState('');
  const [erro, setErro] = useState('');

  useEffect(() => {
    api.get('/turmas', token).then(setTurmas).catch(()=>{});
  }, [token]);

  const enviar = async (e) => {
    e.preventDefault();
    setLoading(true); setSucesso(''); setErro('');
    try {
      const data = await api.post('/mentor/convites', { nome, email, turma_id: turmaId || null, colaborador: tipo === 'colaborador', admin: tipo === 'colaborador' && admin }, token);
      setSucesso(data.mensagem + ' ⚠️ Oriente ' + (tipo === 'colaborador' ? 'o colaborador' : 'o aluno') + ' a verificar a pasta de spam.');
      setNome(''); setEmail(''); setTurmaId(''); setTipo('aluno'); setAdmin(false);
    } catch (err) { setErro(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{padding:'28px 32px',maxWidth:560}}>
      <div style={{marginBottom:24}}>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Convidar Aluno ou Colaborador</div>
        <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>A pessoa receberá um email com link para ativar a conta</div>
      </div>

      <div className="card">
        <form onSubmit={enviar}>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Tipo de acesso</label>
            <select className="input-field" value={tipo} onChange={e=>{setTipo(e.target.value); if (e.target.value !== 'colaborador') setAdmin(false);}}
              style={{width:'100%',padding:'10px 12px',border:'1px solid #E4E6EF',borderRadius:8,fontSize:13,outline:'none',background:'#fff'}}>
              <option value="aluno">Aluno</option>
              <option value="colaborador">Colaborador (equipe SVSLOG)</option>
            </select>
          </div>
          {tipo === 'colaborador' && (
            <div style={{marginBottom:14,background:'#F7F8FC',borderRadius:8,padding:'10px 14px'}}>
              <label style={{display:'flex',alignItems:'center',gap:8,fontSize:13,cursor:'pointer'}}>
                <input type="checkbox" checked={admin} onChange={e=>setAdmin(e.target.checked)} />
                <span><b>É administrador</b> — vê as cotações de todos e pode excluir</span>
              </label>
              <div style={{fontSize:11,color:'#6B7289',marginTop:4}}>Se não marcar, o colaborador usa o simulador só com as próprias cotações.</div>
            </div>
          )}
          <div style={{marginBottom:14}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>{tipo === 'colaborador' ? 'Nome do colaborador' : 'Nome do aluno'}</label>
            <input className="input-field" placeholder="Nome completo" value={nome} onChange={e=>setNome(e.target.value)} required />
          </div>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Email</label>
            <input className="input-field" type="email" placeholder="aluno@email.com" value={email} onChange={e=>setEmail(e.target.value)} required />
          </div>
          <div style={{marginBottom:20}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Turma (opcional)</label>
            <select className="input-field" value={turmaId} onChange={e=>setTurmaId(e.target.value)}
              style={{width:'100%',padding:'10px 12px',border:'1px solid #E4E6EF',borderRadius:8,fontSize:13,outline:'none',background:'#fff'}}>
              <option value="">Sem turma</option>
              {turmas.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
            </select>
          </div>

          {sucesso && <div style={{background:'#E6F7F1',border:'0.5px solid #B8E6D2',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#0A6B47',marginBottom:14}}>✅ {sucesso}</div>}
          {erro && <div style={{background:'#FDEAEA',border:'0.5px solid #E8A5A5',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#922020',marginBottom:14}}>{erro}</div>}

          <button className="btn-primary" type="submit" disabled={loading} style={{width:'100%',padding:13}}>
            {loading ? 'Enviando convite...' : 'Enviar convite por email →'}
          </button>
        </form>
      </div>

      <div className="card" style={{marginTop:16,background:'#F7F8FC',border:'none'}}>
        <div style={{fontSize:12,fontWeight:600,marginBottom:8}}>Como funciona</div>
        <div style={{fontSize:12,color:'#6B7289',lineHeight:1.7}}>
          1. Você preenche o nome e email do aluno aqui<br/>
          2. O sistema envia um email com link de ativação<br/>
          3. O aluno clica, define a senha e já acessa o cockpit<br/>
          4. O link expira em 7 dias<br/>
          5. ⚠️ Oriente o aluno a verificar a pasta de spam
        </div>
      </div>
    </div>
  );
}
